import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import toast from "react-hot-toast";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Navbar from "../../../Components/Navbar/Navbar";
import Table from "../../../Components/TableTemplate/Table";
import {
    dateFormat,
    numberFormat,
    getTodayDate,
    getType,
    selectDropdownStyle,
    getBranchId,
} from "../../../Helpers/Utils/Common";
import DatePicker from "react-datepicker";
import Moment from "moment";

import { searchCashCount, deleteCashCount } from "../../../Helpers/apiCalls/Reports/DailyCashCountApi";
import { getAllBranches } from "../../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../../Components/Footer/Footer";

export default function SalesByItem() {
    let navigate = useNavigate();
    var dateToday = getTodayDate();
    const accountType = getType();
    const [inactive, setInactive] = useState(true);
    const today = new Date();
    const aweekago = new Date();
    aweekago.setDate(aweekago.getDate() - 7);
    const [filterConfig, setFilterConfig] = useState({
        group_cash_counts_by_branch: 1,
        group_cash_counts_by_cashier: 1,
        group_cash_counts_by_date: 1,
        date_from: aweekago,
        date_to: today,
        branch_id: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    })
    const [branches, setBranches] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [sales, setSales] = useState([]);
    
    const dummy = [
        {
            id: "1",
            branch_name: "SM CITY CEBU",
            date: "December 2022",
            amount: "1000",
            added_by: "JOSE RIZAL",
        },
    ]

    // SEARCH USER
    function handleOnSearch(e) {
        const { name, value } = e.target;
        
        setFilterConfig((prev) => {
            return { ...prev, [name]: value };
        });
    }

    function handleSelectChange(e, row) {
        
        
        

        if (e.target.value === "view") {
            navigate("/dailycashcount/shift/" + row.branch_id, {
                state: { 
                    date: row.count_date,
                },
            });
        } else if (e.target.value === "print") {
            navigate("/dailycashcount/shift/" + row.branch_id, {
                state: { 
                    date: row.count_date,
                },
            });
        }
    }

    

    function ActionBtn(row) {
        return (
            <Form.Select
                name="action"
                className="PO-select-action"
                onChange={(e) => handleSelectChange(e, row)}
            >
                <option value="" hidden selected>
                    Select
                </option>
                { accountType === "admin" ? (
                    <option value="view" className="color-options">
                        View
                    </option>
                    ): null
                }
                { accountType === "admin" ? (
                    <option value="print" className="color-options">
                        Print
                    </option>
                    ): null
                }
            </Form.Select>
        );
    }

    function ViewBtn(row) {
        
        return (
            <button
                name="action"
                className="btn btn-sm view-btn-table"
                id={row.id}
                onClick={() => handlePrint(row)}
            >
                View
            </button>
        );
    }
    function handlePrint(row) {
        navigate("/dailycashcount/shift/" + row.branch_id, {
            state: { 
                date: row.count_date,
            },
        });
    }

    async function fetchBranches() {
        setBranches([])
        const response = await getAllBranches();
        
        if (response.data) {
            var allBranches = response.data.data.data
            .filter((data) => {
                return data.is_franchise === "0"
            })
            .map((data) => {
                var branch = data;
                branch.label = data.name
                branch.value = data.id
                return branch;
            });
            if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
                var filteredBranch = allBranches.filter((data) => {
                return data.id === getBranchId()
                })
                setBranches(filteredBranch);
            } else {
                setBranches([{label: "All Branches", value:""}, ...allBranches]);
            }
            
        }
    }

    async function fetchData() {
        setShowLoader(true);
        setSales([])

        const response = await searchCashCount(filterConfig);
        if (response.data) {
            var allBills = response.data.cash_counts.map((bill) => {
                
                var info = bill;
                info.count_date = Moment(bill.count_date).format("MMM DD, YYYY")
                info.amount = numberFormat(bill.physical_count);
                info.system_cash_amount = bill.system_cash_amount ? numberFormat(bill.system_cash_amount) : "0.00";
                info.cash_variance = bill.cash_variance ? numberFormat(bill.cash_variance) : "0.00";
                return info;
            });
            setSales(allBills)
        }
        setShowLoader(false); 
    }

    

    useEffect(() => {
        fetchBranches();
    }, []);

    useEffect(() => {
        fetchData();
    }, [filterConfig]);

    return (
        <div>
            <div className="page">
                <Navbar
                    onCollapse={(inactive) => {
                        setInactive(inactive);
                    }}
                    active={"DS REPORTS"}
                />
            </div>

            <div
                className={`manager-container ${
                    inactive ? "inactive" : "active"
                }`}
            >
                {/* headers */}
                
                <Row className="mb-4">
                    <Col xs={12} lg={7}>
                        <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> DAILY CASH COUNT  </h1>
                    </Col>
                    <Col xs={12} lg={5} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                        <input
                            type="search"
                            name="branch_name"
                            placeholder="Search branch name"
                            className="search-bar"
                            onChange={handleOnSearch}
                        />
                    </Col>
                </Row>

                <div className="tab-content">
                    {/* filters */}
                    <div className="mb-3" />
                    <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                        Filter By:
                    </span>
                    <Row className="PO-filters flex flex-row mx-2 my-1">
                        <Col xs={12} lg={4} className="mb-2 mb-lg-0">
                        <Select
                            className="dropsearch-filter"
                            classNamePrefix="react-select"
                            placeholder="Select Branch"
                            styles={selectDropdownStyle}
                            // value={branch}
                            options={branches}
                            onChange={(e) => { setFilterConfig((prev) => {
                                    return { ...prev, "branch_id": e.value };
                                });}}
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_from}
                            name="date_from"
                            placeholderText={"Select Date"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_from: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter me-4 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                        <Col xs={6} lg={2}>
                        <DatePicker
                            autoComplete="off"
                            selected={filterConfig.date_to}
                            name="date_to"
                            placeholderText={"Select Date"}
                            onChange={(date) => {
                                setFilterConfig((prev) => {
                                    return { ...prev, date_to: date };
                                });
                            }}
                            fixedHeight
                            className="date-filter ps-label-content me-5 form-control"
                            showYearDropdown
                            dateFormatCalendar="MMMM"
                            yearDropdownItemNumber={20}
                            scrollableYearDropdown
                        />
                        </Col>
                    </Row>
                    <div className="mb-2" />

                    <div className="below">
                        {/* table */}
                        <Table
                            tableHeaders={[
                                "-",
                                "DATE",
                                "BRANCH",
                                "DEPOSITED AMT",
                                "SYSTEM CASH AMT",
                                "CASH VARIANCE",
                                "PREPARED BY",
                                "ACTIONS",
                            ]}
                            headerSelector={[
                                "-",
                                "count_date",
                                "branch_name",
                                "amount",
                                "system_cash_amount",
                                "cash_variance",
                                "prepared_by_name",
                            ]}
                            tableData={sales}
                            ActionBtn={(row) => ActionBtn(row)}
                            ViewBtn={(row) => ViewBtn(row)}
                            showLoader={showLoader}
                        />
                    </div>
                    <div className="mb-2" />
                </div>
            </div>
            <Footer/>
        </div>
    );
}
